'use client';

import { Pie, PieChart, Sector, Legend } from 'recharts';
import { PieSectorDataItem } from 'recharts/types/polar/Pie';
import { Card, CardContent } from '@/components/ui/card';
import { ChartConfig, ChartContainer, ChartTooltip } from '@/components/ui/chart';
import CustomTooltip from './CustomTooltip';

export const description = 'A donut chart';

interface PieData {
  name: string;
  value: number;
  fill: string;
}

interface ChartPieDonutProps {
  data: PieData[];
  title?: string;
  description?: string;
  trendText?: string;
  innerRadius?: number;
  outerRadius?: number;
  strokeWidth?: number;
  activeIndex?: number;
  legendProps?: React.ComponentProps<typeof Legend>; // Legend 组件的 props
  cx?: string;
  cy?: string;
}

export default function ChartPieDonut({
  data,
  innerRadius = 35,
  outerRadius = 55,
  strokeWidth = 5,
  activeIndex = -1,
  legendProps = {},
  cx = '50%',
  cy = '50%'
}: ChartPieDonutProps) {
  // 动态生成 chartConfig
  const chartConfig: ChartConfig = {
    ...data.reduce((config, item) => {
      config[item.name] = {
        label: item.name.charAt(0).toUpperCase() + item.name.slice(1),
        color: item.fill
      };
      return config;
    }, {} as Record<string, { label: string; color: string }>)
  };

  return (
    <Card className="flex h-full flex-col justify-center rounded-none border-none shadow-none">
      <CardContent className="flex h-full flex-1 items-center gap-4 p-0">
        <ChartContainer config={chartConfig} className="aspect-square h-full w-full flex-1">
          {/* <ResponsiveContainer width="100%" height="100%"> */}
          <PieChart className="h-full w-full">
            <ChartTooltip cursor={false} content={CustomTooltip} />
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              paddingAngle={5}
              cx={cx}
              cy={cy}
              innerRadius={innerRadius}
              outerRadius={outerRadius}
              strokeWidth={strokeWidth}
              activeIndex={activeIndex}
              activeShape={({
                outerRadius: sectorOuterRadius = 0,
                ...props
              }: PieSectorDataItem) => <Sector {...props} outerRadius={sectorOuterRadius + 8} />}
            />
            <Legend
              {...(legendProps as any)}
              iconSize={legendProps.iconSize || 8}
              iconType={legendProps.iconType || 'square'}
            />
          </PieChart>
          {/* </ResponsiveContainer> */}
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
